import { products } from "@smfa/utils/src/common/products";

export const getPaymentValue = (item, paymentKey, legacyKey) =>
  item?.payments?.[paymentKey] ?? item?.[legacyKey] ?? null;

export const classifyMoney = (amount) => {
  if (
    amount === null ||
    amount === undefined ||
    (typeof amount === "string" && amount.trim() === "")
  ) {
    return { status: "missing", amount: null };
  }

  const numericAmount = Number(amount);
  if (!Number.isFinite(numericAmount)) {
    return { status: "invalid", amount: null };
  }

  return { status: "available", amount: numericAmount };
};

export const resolvePaymentAmount = (item) => ({
  ...classifyMoney(getPaymentValue(item, "amount", "payment_amount")),
  currency: String(
    getPaymentValue(item, "currency", "currency") || "USD",
  ).toUpperCase(),
});

export const resolveRegistrationFee = (item) => {
  const fee = item?.registration_fee;
  if (fee && typeof fee === "object") {
    const resolved = classifyMoney(fee.amount);
    const status =
      resolved.status === "missing" && ["invalid", "missing"].includes(fee.status)
        ? fee.status
        : resolved.status;

    return {
      ...resolved,
      status,
      currency: String(fee.currency || "USD").toUpperCase(),
      source: fee.source || null,
    };
  }

  return resolvePaymentAmount(item);
};

export const getPlanLabel = (planType, productCatalog = products) => {
  if (!planType) {
    return null;
  }

  const product =
    productCatalog.find((item) => item.plan_type === planType) ||
    productCatalog.find((item) => item.legacy_plan_type === planType);

  return (
    product?.name ||
    String(planType)
      .replace(/_/g, " ")
      .replace(/\b\w/g, (letter) => letter.toUpperCase())
  );
};

export const resolveRegistrationPlan = (item, productCatalog = products) => {
  const planType =
    item?.plan_type || item?.payments?.plan_type || item?.registration_plan_type;

  if (!planType) {
    return {
      status: "missing",
      planType: null,
      label: null,
      mismatch: false,
    };
  }

  return {
    status: "available",
    planType,
    label: item?.plan_name || getPlanLabel(planType, productCatalog),
    mismatch: Boolean(item?.plan_mismatch),
  };
};

export const isMemberRegistrationPlan = (planType) =>
  planType === "meeting_member";

export const canViewMemberDetails = (item, productCatalog = products) => {
  const plan = resolveRegistrationPlan(item, productCatalog);

  return (
    isMemberRegistrationPlan(plan.planType) &&
    Boolean(String(item?.email || "").trim())
  );
};
